import React, { useEffect, useState } from "react";
import "./portfolio.css";
import axios from "axios";
import { useAppContext } from "../../contexts/AppContext";
import { Link } from "react-router";
import parse from "html-react-parser";
import { isImage, isVideo } from "../MediaFilter";
import { createPortal } from "react-dom";

function Portfolio() {
  const [portfolioData, setPortfolioData] = useState([]);
  const [portfolioInformation, setPortfolioInformation] = useState([]);
  const [currentImageIndexes, setCurrentImageIndexes] = useState({});
  const [modalMedia, setModalMedia] = useState(null); // { url, type: 'image'|'video' }
  const { backendUrl, translate, getImageUrl } = useAppContext();
  const route = "/Portfolio";
  const portfolioListRoute = "/PortfolioList";

  useEffect(() => {
    const fetchPortfolioData = async () => {
      try {
        const response = await axios.get(`${backendUrl}${route}`);
        if (Array.isArray(response.data) && response.data.length > 0) {
          setPortfolioInformation(response.data);
        }

        const portfolioResponse = await axios.get(`${backendUrl}${portfolioListRoute}`);
        if (Array.isArray(portfolioResponse.data) && portfolioResponse.data.length > 0) {
          setPortfolioData(portfolioResponse.data);

          // Initialize image indexes for slideshow
          const initialIndexes = {};
          portfolioResponse.data.forEach(item => {
            initialIndexes[item.id] = 0;
          });
          setCurrentImageIndexes(initialIndexes);
        }
      } catch (error) {
        console.error("Error fetching portfolio content:", error);
      }
    };
    fetchPortfolioData();
  }, [backendUrl]);

  // Slideshow logic
  useEffect(() => {
    if (portfolioData.length === 0) return;

    const interval = setInterval(() => {
      setCurrentImageIndexes(prev => {
        const next = { ...prev };
        portfolioData.forEach(item => {
          if (item.images && item.images.length > 1) {
            next[item.id] = (prev[item.id] + 1) % item.images.length;
          }
        });
        return next;
      });
    }, 4000);

    return () => clearInterval(interval);
  }, [portfolioData]);

  // Close modal on Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") setModalMedia(null);
    };
    if (modalMedia) {
      document.addEventListener("keydown", handleKeyDown);
    }
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [modalMedia]);

  const openModal = (imageUrl, type) => {
    setModalMedia({ url: imageUrl, type });
  };

  return (
    <div>
      {/* Fullscreen Media Modal */}
      {modalMedia && createPortal(
        <div className="fullscreen-overlay" onClick={() => setModalMedia(null)}>
          <div className="fullscreen-content" onClick={(e) => e.stopPropagation()}>
            {modalMedia.type === "video" ? (
              <video
                src={modalMedia.url}
                controls
                autoPlay
                style={{ maxWidth: "100%", maxHeight: "90vh", borderRadius: "4px" }}
              />
            ) : (
              <img src={modalMedia.url} alt="Portfolio Fullscreen" />
            )}
            <button className="close-btn" onClick={() => setModalMedia(null)}>
              <i className="bi bi-x-lg"></i>
            </button>
          </div>
        </div>,
        document.body
      )}

      {Array.isArray(portfolioInformation) && portfolioInformation.length > 0 && (
        <div className="animated p-4 ">
          <div className="services-color-background">
            <div className="d-block w-100 mt-3 justify-content-center animated">
              {portfolioInformation.map((portfolioInformations, index) => (
                <div key={index} className="text-container">
                  <div className="service-title-container">
                    <div>
                      {portfolioInformations.title && (
                        <h1>{parse(translate(portfolioInformations.title))}</h1>
                      )}
                    </div>
                    <div className="title-underlined"></div>
                  </div>
                  <div className="d-flex w-100 justify-content-center">
                    {portfolioInformations.content && (
                      <p style={{ fontWeight: "400" }}>
                        {parse(translate(portfolioInformations.content))}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div
              className={
                portfolioData.length > 2
                  ? "parent-cotainer overflow-auto "
                  : "parent-cotainer parent-container-space overflow-auto"
              }
            >
              {Array.isArray(portfolioData) &&
                portfolioData.map((datas) => {
                  const currentIdx = currentImageIndexes[datas.id] || 0;
                  const currentSrc = getImageUrl(datas?.images?.[currentIdx]);
                  const rawSrc = `${backendUrl}/${datas?.images?.[currentIdx]}`;

                  return (
                    <div
                      className="portfolio-container portfolio-container-min bg-white"
                      key={datas?.id}
                    >
                      <div className="photo-container d-flex justify-content-center">
                        {isImage(rawSrc) ? (
                          <img
                            className="photo fade-in portfolio-media-clickable"
                            key={currentIdx}
                            src={currentSrc}
                            alt="portfolio"
                            loading="lazy"
                            title="Double-click to expand"
                            onDoubleClick={() => openModal(currentSrc, "image")}
                          />
                        ) : isVideo(rawSrc) ? (
                          <video
                            className="photo fade-in portfolio-media-clickable"
                            key={currentIdx}
                            src={currentSrc}
                            loading="lazy"
                            controls
                            onDoubleClick={() => openModal(currentSrc, "video")}
                          />
                        ) : (
                          <div></div>
                        )}
                      </div>

                      <div className=" description-container ">
                        <div>
                          <Link className="text-decoration-none text-black" to={datas.content || "#"}>
                            <p className="descriptions">
                              {parse(translate(datas?.title))}
                            </p>
                          </Link>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Portfolio;
